/*
 * AJAX lazy loading for team members shortcode
 * 
 */

(function($) {
    var moreBtn = $('.js-team-members-show-more');
    var blockId = moreBtn.data('blockid');
    var offset = moreBtn.data('offset');
    moreBtn.on('click',
    function() {
        if ($(this).attr('disabled') === 'disabled') {
            return false;
        }
        $(this).attr('disabled', 'disabled');
        $.post(
            CT.ajaxurl,
            {
                // here we declare the parameters to send along with the request
                // this means the following action hooks will be fired:
                // wp_ajax_nopriv_load_more_members and wp_ajax_load_more_members
                action : 'load_more_members',
                offset : offset,
                orderby: moreBtn.data('orderby'),
                order: moreBtn.data('order'),
                max_items: moreBtn.data('max_items'),
                show_vps: moreBtn.data('show_vps')
            },
            function( response ) {
                $(this).removeAttr('disabled');
                var newMembers = $(response.html).hide().fadeIn('slow');
                $('#'+blockId).append(newMembers);
                
                offset += moreBtn.data('max_items');
                                
                if (offset >= response.total) {
                    moreBtn.hide();
                }
                
            }
        );
        return false;
    });
})(jQuery);